import { UPDATE_FOCUS_AREA_GEOMETRY } from './index';

export const updateFocusAreaGeometryAction = (selectedFocusArea) => ({
    type: UPDATE_FOCUS_AREA_GEOMETRY,
    selectedFocusArea
});